export default {
  reportBuilder: 'Kreator raportów',
  subheadline: 'Te ustawienia definiują globalny wygląd plików PDF generowanych przez Qmulus.',
  reportForm: {
    size: {
      label: 'Domyślny rozmiar papieru',
      tooltip: 'Określa rozmiar papieru, który jest zawsze wybierany domyślnie.',
    },
    language: {
      label: 'Język',
      tooltip: 'Wybór języka określa sposób wyświetlania znaczników czasu i innych zlokalizowanych fragmentów tekstu w raporcie.',
    },
    logo: {
      label: 'Logo',
      tooltip: 'Wybrane logo jest wyświetlane w nagłówku każdego raportu.',
    },
    header: {
      height: {
        tooltip: 'Określa wysokość nagłówka używaną na każdej stronie raportu.',
      },
      contentLeft: {
        tooltip: 'Określa lewy tekst nagłówka wyświetlany na każdej stronie raportu.',
      },
      contentCenter: {
        tooltip: 'Określa wyśrodkowany tekst nagłówka wyświetlany na każdej stronie raportu.',
      },
      contentRight: {
        tooltip: 'Określa prawy tekst nagłówka wyświetlany na każdej stronie raportu.',
      },
    },
    footer: {
      contentLeft: {
        tooltip: 'Określa lewy tekst stopki wyświetlany na każdej stronie raportu.',
      },
      contentCenter: {
        tooltip: 'Określa wyśrodkowany tekst stopki wyświetlany na każdej stronie raportu.',
      },
      contentRight: {
        tooltip: 'Określa prawy tekst stopki wyświetlany na każdej stronie raportu.',
      },
    },
  },
  errors: {
    unsupportedFileType: 'Aktualne logo jest w nieobsługiwanym formacie pliku. Prześlij nowe logo.',
    logoLoadingFailure: 'Nie udało się załadować aktualnego logo. Zalecamy przesłanie nowego logo.',
  },
};
